import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;
import { css } from 'styled-components';
export default {
  xs2: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 400;\n    letter-spacing: 0;\n  "]))),
  xs: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    letter-spacing: 0;\n  "]))),
  s: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    line-height: 18px;\n    font-weight: 400;\n    letter-spacing: 0;\n  "]))),
  base: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 400;\n    letter-spacing: 0;\n  "]))),
  l: css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: 20px;\n    line-height: 26px;\n    font-weight: 600;\n    letter-spacing: 0;\n  "]))),
  xl: css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    font-size: 26px;\n    line-height: 34px;\n    font-weight: 600;\n    letter-spacing: 0;\n  "]))),
  xl2: css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: 38px;\n    line-height: 44px;\n    font-weight: 600;\n    letter-spacing: 0;\n  "]))),
  xl3: css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    font-size: 52px;\n    line-height: 56px;\n    font-weight: 600;\n    letter-spacing: -0.76px;\n  "]))),
  xl4: css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    font-size: 60px;\n    line-height: 64px;\n    font-weight: 600;\n    letter-spacing: -1px;\n  "]))),
  size: {
    xs2: '10px',
    xs: '12px',
    s: '14px',
    base: '16px',
    l: '20px',
    xl: '26px',
    xl2: '38px',
    xl3: '52px',
    xl4: '60px'
  },
  lineHeight: {
    xs2: '12px',
    xs: '16px',
    s: '18px',
    base: '22px',
    l: '26px',
    xl: '34px',
    xl2: '44px',
    xl3: '56px',
    xl4: '64px'
  },
  weight: {
    thin: 100,
    extraLight: 200,
    light: 300,
    medium: 500,
    regular: 'normal',
    semibold: 600,
    bold: 'bold',
    extraBold: 800,
    black: 900
  },
  family: {
    semiBold: css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      font-family: 'Metropolis-Semibold', sans-serif;\n    "])))
  }
};